import { selector } from 'recoil';
import { fetchedPaymentInformationAtom } from '../atoms/fetchedPaymentInformationAtom';
import { OnlineSales } from 'gw-edge-client';

export const getBankAccountValidityStatusSelector = selector<boolean>({
    key: 'getBankAccountValidityStatusSelector',
    get: async ({ get }) => {
        const { bankReference, accountNumber } = get(fetchedPaymentInformationAtom);
        if (!bankReference || !accountNumber) {
            return false;
        }
        const bankAccountStatus = await OnlineSales.validateBankAccountData(
            bankReference,
            accountNumber
        );

        return bankAccountStatus.valid ?? false;
    }
});
